module.exports = __webpack_public_path__ + "UG.png?3b301f8206a9becf8e01b5494435183a";